export default __webpack_public_path__ + "static/media/play1.c29e567a.svg";